export default __webpack_public_path__ + "static/innerbeliveimg-a1a88c38db0abb3a30928da154d8926e.png";